/******************************************************************
 *
 * @usage
 *
 * [必須]
 *
 * data-sticky='fixable-content'
 *  これをFIXしたい要素につける
 *
 * data-sticky='main-content'
 *  これをFIXする要素の基準・親となる要素につける
 *
 * [任意]
 * data-sticky-margin-top=30
 *  トップから30pxのところでフィックスする。data-sticky='fixable-content'につける。
 *
 * data-sticky-offset=111
 *  調整
 *
 * data-sticky-exclude='xxx'
 *  計算から除外したいコンテンツに付ける
 *  例: data-sticky-exclude='main_content_bottom'
 *      メインコンテンツの下部を計算する際に、この属性が指定された要素の高さは除外される
 ******************************************************************/
var STICKY_DEBUG = false;
(function ($) {

    if (WP_GLOBAL.is_mobile) {
        return;
    }

    var fix, main, fix_initial_position_top, fix_w, fix_h, fixed_with_margin_top, exclude_main_content_bottoms;

    $(function () {

        if ($('body').hasClass('mobile') || $('[data-sticky]').length < 2) {
            return;
        }

        main = $('[data-sticky="main-content"]'); //固定する要素を収める範囲
        fix = $('[data-sticky="fixable-content"]'); //固定したいコンテンツ
        fixed_with_margin_top = 'undefined' !== typeof fix.data('sticky-margin-top') ? fix.data('sticky-margin-top') : 0;
        fix_initial_position_top = fix.offset().top - fix.position().top;
        fix_w = fix.width() + getPadding(fix, 'left') + getPadding(fix, 'right') + get_border_width(fix, 'left') + get_border_width(fix, 'right');
        fix_h = fix.outerHeight(true) + getPadding(fix, 'top') + getPadding(fix, 'bottom');
        exclude_main_content_bottoms = $('[data-sticky-exclude=main_content_bottom]').length > 0 ? $('[data-sticky-exclude=main_content_bottom]').height() : 0;
        var fix_custom_offset = typeof fix.data('sticky-offset') !== 'undefined' ? fix.data('sticky-offset') : 0;

        main.css('position', 'relative');

        var fix_content_offset_top = fix.offset().top,
            mainTop = main.offset().top,
            w = $(window);

        // メインコンテンツが小さすぎてStickyできない場合はバグを避けるため処理自体を止める
        if (main.height() < fix.height() + fix_content_offset_top) {
            return;
        }

//        log('main', main);
//        log('fix', fix);
//        log('fixed_with_margin_top', fixed_with_margin_top);
//        log('fix_initial_position_top', fix_initial_position_top);
//        log('fix_w', fix_w);
//        log('fix_h', fix_h);
//        log('exclude_main_content_bottoms', exclude_main_content_bottoms);
//        log('fix_custom_offset', fix_custom_offset);
//        log('fix_content_offset_top', fix_content_offset_top);

        var listener = function () {
            // リアルタイムで変わる数値を取得する
            var current_window_top = w.scrollTop();
            var current_fix_content_bottom = current_window_top + fix_h;
            var main_content_bottom = mainTop + main.outerHeight() - exclude_main_content_bottoms;

            if (is_at_the_bottom_of_the_main(current_fix_content_bottom, main_content_bottom - fixed_with_margin_top - fix_custom_offset)) {

                var fix_here = main_content_bottom - fix_h - fix_initial_position_top - fix_custom_offset;

                fix.trigger('scroll_to_the_end', [fix_here])
                    .removeClass('fixed')
                    .addClass('fixed-at-the-end');

            } else if (does_restart_scrolling_between_the_main(current_window_top, fix_content_offset_top)) {

                fix.trigger('restart_scrolling')
                    .addClass('fixed')
                    .removeClass('fixed-at-the-end');

            } else if (does_start_scrolling_between_the_main(current_window_top, fix_content_offset_top)) {

                fix.trigger('start_scrolling')
                    .addClass('fixed')
                    .removeClass('fixed-at-the-top');

            } else if (is_scrolling_between_the_main(current_window_top, fix_content_offset_top)) {

                // scrolling and do nothing

            } else if (is_at_top_of_the_main(current_window_top, fix_content_offset_top)) {

                fix.trigger('scrolled_back_to_the_top')
                    .removeClass('fixed')
                    .addClass('fixed-at-the-top');

            }
        };

        fix.on('scroll_to_the_end', function (e, fix_here) {
            log('scroll_to_the_end');
            fix.css({
                position: 'absolute',
                top: fix_here
            });
        });

        fix.on('start_scrolling', function (e) {
            log('start_scrolling');
            fix.css({
                position: 'fixed',
                top: fixed_with_margin_top,
                width: fix_w
            });
        });

        fix.on('restart_scrolling', function (e) {
            log('restart_scrolling');
            fix.css({
                position: 'fixed',
                top: fixed_with_margin_top,
                width: fix_w
            });
        });

        fix.on('scrolled_back_to_the_top', function (e) {
            log('scrolled_back_to_the_top');
            fix.css({
                position: 'static',
                top: 0,
                width: fix_w
            });
        });


        w.on('scroll', listener);
    });

    /***************************
     *
     * メインコンテンツの上部か下部に、フィックスコンテンツが達しているかどうか
     *
     ***************************/
    function is_at_the_bottom_of_the_main(current_fix_content_bottom, main_content_bottom) {
        log('current_fix_content_bottom', current_fix_content_bottom);
        log('main_content_bottom', main_content_bottom);

        return current_fix_content_bottom >= main_content_bottom;
    }

    function is_at_top_of_the_main(current_window_top, fix_content_offset_top) {
        return current_window_top <= fix_content_offset_top - fixed_with_margin_top;
    }

    /***************************
     *
     * スクロール中かどうか
     *
     ***************************/
    function is_scrolling_between_the_main(current_window_top, fix_content_offset_top) {
        return current_window_top >= fix_content_offset_top - fixed_with_margin_top && fix.hasClass('fixed')
    }

    function does_restart_scrolling_between_the_main(current_window_top, fix_content_offset_top) {
        return current_window_top >= fix_content_offset_top - fixed_with_margin_top && fix.hasClass('fixed-at-the-end');
    }

    function does_start_scrolling_between_the_main(current_window_top, fix_content_offset_top) {
        return current_window_top >= fix_content_offset_top - fixed_with_margin_top && !fix.hasClass('fixed');
    }

    function log(title, obj) {
        if (STICKY_DEBUG) {
            console.log(title, obj)
        }
    }

})(jQuery);

function getPadding($target, placement) {
    return parseInt($target.css('padding-' + placement), 10);
}

function get_border_width($target, placement) {
    return parseInt($target.css('border-' + placement + '-width'), 10);
}

